import type { Locale } from "@/i18n/locales";

import { tradableAssets as en } from "./en/tradable-assets";
import { tradableAssets as de } from "./de/tradable-assets";
import type { TradableAssetsContent } from "./types";

const TRADABLE_ASSETS: Readonly<Record<Locale, TradableAssetsContent>> = { en, de };

export function tradableAssetsFor(locale: Locale): TradableAssetsContent {
  return TRADABLE_ASSETS[locale];
}
